import React, { createContext, useContext, useState, useEffect } from 'react'

import { useMatchMedia } from 'hooks'

const LayoutContext = createContext()

const LayoutContextProvider = ({ children, ...props }) => {
  const [isSearchMenuOpen, setIsSearchMenuOpen] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const { isMobile, isTablet } = useMatchMedia()

  const toggleSearchMenu = () => {
    setIsSearchMenuOpen(prevState => !prevState)
  }

  const toggleMobileMenu = () => {
    setIsSearchMenuOpen(false)
    setIsMobileMenuOpen(prevState => !prevState)
  }

  useEffect(() => {
    if (!(isMobile || isTablet)) {
      setIsMobileMenuOpen(false)
    }
  }, [isMobile, isTablet])

  return (
    <LayoutContext.Provider
      value={{
        isSearchMenuOpen,
        setIsSearchMenuOpen,
        toggleSearchMenu,
        isMobileMenuOpen,
        toggleMobileMenu,
      }}
      {...props}
    >
      {children}
    </LayoutContext.Provider>
  )
}
const useLayout = () => useContext(LayoutContext)

export { LayoutContextProvider, useLayout }
